const Marks = {
  ' ': true,
  ',': true,
  '>': true,
  '<': true,
  '.': true,
  '?': true,
  '/': true,
  ':': true,
  ';': true,
  '|': true,
  '\\': true,
  '"': true,
  "'": true,
  '{': true,
  '[': true,
  ']': true,
  '}': true,
  '`': true,
  '~': true,
  '!': true,
  '@': true,
  '#': true,
  $: true,
  '%': true,
  '^': true,
  '&': true,
  '*': true,
  '(': true,
  ')': true,
  _: true,
  '-': true,
  '+': true,
  '=': true,
};

export default Marks;
